export default {"src":"/_next/static/media/icon-marketplace-bounty.bda957b3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};